<template>
    <!-- Start Footer Area -->
    <footer class="footer-area bg-f7fafd">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <div class="logo">
                            <a href="/">
                                <img src="../../assets/img/logo.png" alt="logo" />
                            </a>
                        </div>
                        <p>We believe the quality of the software is important.</p>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-footer-widget pl-5">
                        <!-- <h3>Company</h3>
                        <ul class="list">
                            <li><a href="#">About Us</a></li>
                            <li><a href="#">Services</a></li>
                            <li><a href="#">Features</a></li>
                            <li><a href="#">Our Pricing</a></li>
                            <li><a href="#">Latest News</a></li>
                        </ul> -->
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <!-- <h3>Support</h3>
                        <ul class="list">
                            <li><a href="#">FAQ's</a></li>
                            <li><a href="#">Privacy Policy</a></li>
                            <li><a href="#">Terms & Condition</a></li>
                            <li><a href="#">Community</a></li>
                            <li><a href="#">Contact Us</a></li>
                        </ul> -->
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="single-footer-widget">
                        <h3>Address</h3>

                        <ul class="footer-contact-info">
                            <li><feather type="map-pin"></feather> 78 Soi Khubon 6, Ram Inthra rd. Khwaend Ram Inthra, Khet Khan na Yao, Bangkok 10230, Thailand</li>
                            <li><feather type="mail"></feather> Email: <a href="mailto:contact@thedeft.io">contact@thedeft.io</a></li>
                            <li><feather type="phone-call"></feather> Phone: <a href="tel:+66829899160">082-989-9160</a></li>
                        </ul>
                        <ul class="social-links">
                            <li><a href="https://www.facebook.com/thedeft.io" target="_blank" class="facebook"><feather type="facebook"></feather></a></li>
                            <li><a href="https://github.com/The-Deft" target="_blank" class="github"><feather type="github"></feather></a></li>
                            <!-- <li><a href="#" class="twitter"><feather type="twitter"></feather></a></li>
                            <li><a href="#" class="instagram"><feather type="instagram"></feather></a></li>
                            <li><a href="#" class="linkedin"><feather type="linkedin"></feather></a></li> -->
                        </ul>
                    </div>
                </div>

                <div class="col-lg-12 col-md-12">
                    <div class="copyright-area">
                        <p>Copyright &copy;2020 THE DEFT TECHNOLOGY. All Rights Reserved</p>
                        <!-- <p>&copy;2020 THE DEFT TECHNOLOGY Co.,Ltd.</p> -->
                    </div>
                </div>
            </div>
        </div>

        <img src="../../assets/img/map.png" class="map" alt="map">
        <div class="shape1"><img src="../../assets/img/shape1.png" alt="shape"></div>
        <div class="shape8 rotateme"><img src="../../assets/img/shape2.svg" alt="shape"></div>
        <!-- <div class="go-top"><feather type="arrow-up"></feather></div> -->

        <back-to-top bottom="50px" right="50px">
            <div class="go-top"><feather type="arrow-up"></feather></div>
        </back-to-top>
    </footer>
    <!-- End Footer Area -->
</template>

<script>
import BackToTop from 'vue-backtotop'
export default {
    name: 'Footer',
    components: { BackToTop }
}
</script>